<div *ngIf="page && page.ImageData && page.ImageData.length>0" class="page-nub" page-nub></div>

<app-cards *ngIf="isLoaded && cards" [page]="page" [cards]="cards" >

</app-cards>

<app-page *ngIf="isLoaded && !cards" [page]="page">

</app-page>
